# Задержка перед перерисовкой (позволяет избежать ненужных лагов)
REDRAW_DELAY = 800

App.HeatMapComponent = Em.Component.extend
  session:  Em.inject.service()
  classNames: [ 'heatmap-chart' ]

  radius: 15
  maxIntensity: 3

  mapInstance:     null
  heatmapInstance: null
  points: []

  redrawHeatMap: (->
    map = @get('mapInstance')

    # Чтобы вызвать после registerMap
    Em.run.later =>
      points = @get('points')
      return unless Em.isArray(points)
      return unless window.google

      ordersPoints = points.map( (p) =>
        return null if p[0] == 0 and p[1] == 0
        new google.maps.LatLng(p[0], p[1])
        ).compact()

      # Привязываем окно карты к координатам
      bounds = new google.maps.LatLngBounds()
      ordersPoints.forEach (d) =>
        bounds.extend(d)

      map.fitBounds(bounds)

      # Настраиваем хитмап
      heatmap = @get('heatmapInstance')

      unless heatmap
        heatmap = new google.maps.visualization.HeatmapLayer()
        heatmap.setMap(map)
        @set('heatmapInstance', heatmap)

      pointArray = new google.maps.MVCArray(ordersPoints)

      heatmap.set('radius', @get('radius'))
      heatmap.set('maxIntensity', @get('maxIntensity'))
      heatmap.set('data', pointArray)
    , REDRAW_DELAY
  ).observes('points').on('didInsertElement')


  registerMap: (->
    return unless @$().get(0)
    return unless window.google

    mapOptions = {
      zoom: 13
      center: new google.maps.LatLng(0.0, 0.0)
      mapTypeId: google.maps.MapTypeId.ROADMAP
      scrollwheel: false
      disableDefaultUI: true
      zoomControl: true
      fullscreenControl: true
      # styles: [{ stylers: [{saturation: -100 }] }]
    }

    @get('session.currentUser').stat('googleMap','heatmap')
    map = new google.maps.Map(@$().get(0), mapOptions)

    @set('mapInstance', map)
  ).on('didInsertElement')
